import React from "react";
import { Card, Typography, Divider, Row, Col } from "antd";
import SectionHeader from "./GetStarted/SectionHeader";
import Description from "./General/Description";
import CategorySelector from "./CategorySelector";
import LogoUploader from "./General/LogoUploader";
import Name from "./General/Name";
import metaData from "../data/metaData";

const { Title } = Typography;

const BrandProfile = ({ state = {}, readOnly = true }) => {
  const { data, form, onChange } = state;

  return (
    <Card
      title={<SectionHeader title="Brand" />}
      style={{
        marginBottom: "1rem",
        border: "2px solid var(--ion-color-step-150)",
      }}
    >
      <Row align="top">
        <Col span={24}>
          {/* Use LogoUploader only in editable mode */}
          {readOnly ? (
            <img
              style={{ width: "5rem", height: "5rem", objectFit: "cover", marginRight: "0.5rem" }}
              src={metaData.blobPreURL + "clientUpload-" + data?.logo + ".jpeg" + metaData.blobPostURL}
            />
          ) : (
            <LogoUploader logo={data?.logo} onFinish={onChange} readOnly={false} />
          )}

          {/* Render Name based on readOnly prop */}
          {readOnly ? (
            <Title level={4}>{data?.name}</Title>
          ) : (
            <Name
              state={{
                data: data?.name,
                form: form,
                rules: [{ required: true, message: "required" }],
                onChange: onChange,
              }}
              readOnly={false}
              maxLength={60}
              showCount
            />
          )}
        </Col>

        <Divider style={{ background: "var(--ion-color-step-200)", height: "2px", margin: "3rem 0" }} />

        <Col span={24}>
          <Title level={5} style={{ margin: "0 0 1rem 0" }}>
            Category
          </Title>
          <CategorySelector
            state={{
              data: data?.category,
              form: form,
              rules: [{ required: true, message: "required" }],
              onChange: onChange,
            }}
            readOnly={readOnly}
          />
        </Col>
      </Row>

      <Divider style={{ background: "var(--ion-color-step-200)", height: "2px", margin: "3rem 0" }} />

      <Description
        state={{
          data: data?.description,
          form: form,
          onChange: onChange,
          keyName: "description",
        }}
        readOnly={readOnly}
        placeholder={"A brief description of your brand"}
      />
    </Card>
  );
};

export default BrandProfile;
